import { css } from "@emotion/react";
import SearchIcon from "../../icons/open-in-new.svg?react";
import CompassIcon from "../../icons/compass-black.svg?react";
import { useAppContext } from "../../contexts/AppContext";

const SearchInCompassIcon = () => {
  const { searchValue } = useAppContext();

  const urlEncodeSearchValue = encodeURIComponent(searchValue);

  const url = `${window.compassUrl ?? import.meta.env.VITE_COMPASS_URL}/search?search=${urlEncodeSearchValue}`;

  return (
    <a
      css={({ colours }) => css`
        height: 31px;
        flex-grow: 0;
        display: flex;
        gap: 4px;
        align-items: center;
        padding: 6px 10px;
        border-radius: 6px;
        box-shadow:
          0 1px 4px 0 rgba(9, 9, 11, 0.08),
          0 0 12px -6px ${colours.uIGrey.light._60},
          inset 0 0 4px 2px ${colours.uIGrey.light._5},
          inset 0 0 0 0.5px #fff,
          inset 0 -17px 10px -1px ${colours.uIGrey.light._15};
        background-color: ${colours.uIGrey.light._10};

        font-size: 14px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.58;
        letter-spacing: normal;
        color: ${colours.uIGrey.dark._30};
      `}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        e.preventDefault();
        window.top?.open(url, "_blank");
      }}
    >
      Search in{" "}
      <CompassIcon
        css={css`
          height: 13px;
          width: 70px;
          padding-top: 1px;
        `}
      />
      <SearchIcon aria-label="Search Icon" />
    </a>
  );
};

export default SearchInCompassIcon;
